import { BLAuth } from "@brandlive/client-auth";
import { API_HOST } from "@/utils/connections/endpoints";
import { getFromAppConfigForCurrentLocation } from "@/utils/auth/get-from-app-config-for-current-location";

const fromApp = getFromAppConfigForCurrentLocation();

export default new BLAuth(API_HOST, process.env.REACT_APP_LOGIN_HOST as string, false, fromApp);